import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import CloudName from "./CloudName";
import EnterpriseApp from "./EnterpriseApp/EnterpriseApp";
import CommonTemplate from "./CommonTemplate";
import MetaModel from "./MetaModel";
import ScreenAdapter from "./ScreenAapter";
import LoaddingSpin from "./LoaddingSpin";
import styles from "./bigScreen.less";


function BigScreen(props) {
  const { model, customProps, endProcess, hasListstatisticsInvoke, getLangMsg } = props;
  const data = customProps.data;
  const method = data?.method; // 返回数据的接口key
  const taskId = data?.taskId;
  const defaultcloudid = data?.defaultcloudid;
  const defaultappdid = data?.defaultappid || '' // 

  let timer = useRef(null);
  let hasProcess = useRef(null); // 是否返回了进度'getrefreshstatisticsprocess'
  let hasListstatistics = useRef(null); // 是否返回了模型资产列表'bizappid'
  let refreshClickFlag = useRef(null);
  let numRef = useRef(null) // 用于判断是否初次显示

  const [cloudId, setCloudId] = useState("");
  const [pageState, setPageState] = useState(0); // 页面状态
  const [bizappid, setBizappid] = useState(defaultappdid); // 页面状态

  // 页面状态
  // pageState === 3 ：有进度，有云数据。同点击刷新状态。
  // pageState === 2 ：无进度，有云数据。有云数据状态。
  // pageState === 1 ：有进度，无云数据。初始页面刷新。
  // pageState === 0 ：无进度，无云数据。初始页面刷新。

  useEffect(() => {
    numRef.current = 0
    model.invoke("listcloud");
    return () => {
      timer.current && clearInterval(timer.current);
      timer.current = null;
    };
  }, []);

  useEffect(() => {
    // 初始页面加载时，Liststatistics请求回来，才轮询
    // hasListstatisticsInvoke
    if (hasListstatisticsInvoke) {
      model.invoke("getrefreshstatisticsprocess");
      timer.current = setInterval(getProcess, 5000)
    }
  }, [hasListstatisticsInvoke])

  // useEffect(() => {
  //   if (endProcess) {
  //     // 清空轮询
  //     timer.current && clearInterval(timer.current);
  //     timer.current = null;
  //     // 页面2
  //     setPageState(2); // 有云数据状态
  //   }
  // }, [endProcess])

  useEffect(() => {
    switch(method) {
      case 'getrefreshstatisticsprocess':
        // hasProcess = true
        hasProcess.current = true
        break;
      case 'liststatistics':
        // hasListstatistics = true
        hasListstatistics.current = true
    }
    // 初次请求p和bizappid返回数据后
    if (hasProcess.current && hasListstatistics.current) {
      numRef.current = numRef.current < 10 ? numRef.current + 1 :  numRef.current
      if (data.App) {
        if (endProcess) {
          setPageState(2); // 有云数据状态
          // 清空轮询
          timer.current && clearInterval(timer.current);
          timer.current = null;
        } else if (data.p<100 && data.p>=0) {
          setPageState(3) // 页面2 刷新状态
          numRef.current = 0
        } else if (data.p === 100) {
          setPageState(2); // 有云数据状态
          // 清空轮询
          timer.current && clearInterval(timer.current);
          timer.current = null;
          // 请求bizapp 1.点击刷新状态时，重新请求;2.初始页面，返回进度为100，重新请求
          if (refreshClickFlag.current || numRef.current === 1) {
            model.invoke('liststatistics', `{"bizappid": "${bizappid}"}`) // 
            refreshClickFlag.current = false
          }
        } 
      } else {
        // 无云数据
        setPageState(1); // 有云数据状态
        if (endProcess) {
          // 刷新
          model.invoke("refreshstatistics");
        } else if (data.p<100 && data.p>=0) {
        } else if (data.p === 100) {
          // 清空轮询
          timer.current && clearInterval(timer.current);
          timer.current = null;
          // 请求bizapp
          defaultappdid && model.invoke('liststatistics', `{"bizappid": "${defaultappdid}"}`)
        }
      }
    }
  }, [data, endProcess]);

  // 默认云存在后，获取app
  useEffect(() => {
    defaultcloudid &&
      model.invoke("listapp", `{"bizcloudid": "${defaultcloudid}"}`);
  }, [defaultcloudid]);

  useEffect(() => {
    defaultappdid && model.invoke('liststatistics', `{"bizappid": "${defaultappdid}"}`)
  }, [defaultappdid])

  const getCloudId = (id) => {
    setCloudId(id);
  };

  const getProcess = () => {
    model.invoke("getrefreshstatisticsprocess");
  };

  // 点击刷新
  const refreshClick = () => {
    setPageState(3) // 页面2 刷新状态
    // 获取刷新进度
    model.invoke("refreshstatistics");
    timer.current = setInterval(getProcess, 5000);
    setTimeout(() => {
      refreshClickFlag.current = true;
    }, 6000);
  };

  // 点击获取模型资产
  const getBizData = (id) => {
    model.invoke('liststatistics', `{"bizappid": "${id}"}`)
    setBizappid(id)
  }

  return (
    <>
      {pageState === 2 || pageState === 3 ? (
        <div className={styles.bigScreenWrapper}>
          <ScreenAdapter>
            <div id="bigScreen" className={styles.bigScreen}>
              <CloudName
                model={model}
                clouds={data?.clouds || []}
                defaultcloudid={defaultcloudid}
                getCloudId={getCloudId}
              />
              <div id="cloudData" className={styles.cloudData}>
                <EnterpriseApp
                  model={model}
                  getLangMsg={getLangMsg}
                  data={data}
                  cloudId={cloudId}
                  refreshClick={refreshClick}
                  getBizData={getBizData}
                  pageState={pageState}
                />
                <CommonTemplate data={data?.Common || {}} model={model} getLangMsg={getLangMsg} />
                <MetaModel data={data?.Meta || {}} model={model} getLangMsg={getLangMsg} />
              </div>
            </div>
          </ScreenAdapter>
          <div className={styles.zhanwei}></div>
        </div>
      ) : (
        <div className={styles.bigScreenWrapper}>
          <ScreenAdapter loadding="loadding">
            {/* <ScreenAdapter loadding='loadding'> */}
            <div id="bigScreen" className={styles.bigScreen}>
              <LoaddingSpin model={model} getLangMsg={getLangMsg} />
            </div>
          </ScreenAdapter>
          <div className={styles.zhanwei}></div>
        </div>
      )}
    </>
  );
}

BigScreen.propTypes = {
  data: PropTypes.object,
};

export default BigScreen;
